import { Anchor } from "@newsela/angelou";
import { useRouter } from "next/router";

import {
  joinNowAnchorCss,
  signInAnchorCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfileUnauthenticatedItems/UserProfileUnauthenticatedItems.styles";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useSignInUrl from "@/users/useSignInUrl";

const UserProfileUnauthenticatedItems = () => {
  const { asPath } = useRouter();
  const signInUrl = useSignInUrl();

  return (
    <>
      <Anchor
        __cssFor={joinNowAnchorCss}
        href={`${MONOLITH_ORIGIN}/join?next=${asPath}`}
        dataProps={{ "data-qa-selector": "global-nav-user-join-now" }}
      >
        Join now
      </Anchor>

      <Anchor
        href={signInUrl}
        __cssFor={signInAnchorCss}
        dataProps={{ "data-qa-selector": "global-nav-user-sign-in" }}
      >
        Sign in
      </Anchor>
    </>
  );
};

UserProfileUnauthenticatedItems.displayName = "UserProfileUnauthenticatedItems";
export { UserProfileUnauthenticatedItems };
